<script setup>
import { computed } from 'vue';

const props = defineProps({
	updatePage: Function,
	filteredForSaved: Boolean
});

function clearFilters() {
	props.updatePage('curriculum');
}
</script>

<template>
	<a
		id="clear-filters"
		:class="!filteredForSaved ? 'hidden' : ''"
		@click.stop="clearFilters()"
	>
		<p>Clear Filters</p>
	</a>
</template>

<style lang="scss" scoped>
#clear-filters {
	box-shadow: var(--floatingShadow);
	color: var(--text1);
	display: flex;
	flex-flow: column;
	gap: 4px;
	justify-content: center;
	align-items: center;

	background-color: var(--bg3);
	border: 1px solid var(--border);
	border-radius: 20px;
	padding: var(--nav-padding);

	position: fixed;
	inset: auto calc(var(--nav-padding) - 6px) 68px;
	z-index: 8;

	&:hover {
		background-color: var(--bg2);
		cursor:pointer;
	}
}
p {
	font-weight: bold;
	margin: 0;
}
.tablet ~ #clear-filters {
	inset: auto auto 70px calc(var(--nav-padding) - 6px);
	width: calc(var(--sidebar-width) - 22px - (var(--nav-padding)* 2) - 1px);
}
@media(min-width:1024px){
	#clear-filters,
	.tablet + #clear-filters {
		// background-color: var(--bg1);
		// border: unset;
		// border-radius: unset;
		// box-shadow: unset;
		padding: 10px var(--nav-padding);
		bottom: 8px;
		left: 8px;
		width: calc(var(--sidebar-width) - 16px - var(--nav-padding) - var(--nav-padding));
	}
}

</style>
